import { render, staticRenderFns } from "./NewInstanceFloatingButton.vue?vue&type=template&id=0a38e81c&scoped=true"
import script from "./NewInstanceFloatingButton.vue?vue&type=script&lang=js"
export * from "./NewInstanceFloatingButton.vue?vue&type=script&lang=js"
import style0 from "./NewInstanceFloatingButton.vue?vue&type=style&index=0&id=0a38e81c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a38e81c",
  null
  
)

export default component.exports